import { ExpenseCategoryType, ExpenseClaimState } from './../../../../core/models/expense.model';
import { Permissions } from './../../../../core/constants/permissions';
import { ExpenseClaimViewModel } from 'app/core/models/expense.model';
import { AuthService } from './../../../../core/services/auth.service';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfirmWipActionModalComponent } from "./confirm-wip-action-modal/confirm-wip-action-modal.component";
import { ExpenseService } from "../../../../core/services/expense.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { LogHelper } from "../../../../core/helpers/log.helper";
import { RoleNames } from "../../../../core/constants/role-names";

@Component({
  selector: 'app-expense-actions',
  templateUrl: './expense-actions.component.html',
  styleUrls: ['./expense-actions.component.scss']
})
export class ExpenseActionsComponent {
  @ViewChild('confirmWipModal') confirmWipModal: ConfirmWipActionModalComponent;

  private expenseToClone: ExpenseClaimViewModel | null = null;

  @Input() expense: ExpenseClaimViewModel;
  @Input() selectedTab: ExpenseClaimState;
  @Input() dataLoaded: boolean;
  @Input() processingRequest: boolean;

  @Output() edit: EventEmitter<string> = new EventEmitter<string>();
  @Output() check: EventEmitter<ExpenseClaimViewModel> = new EventEmitter<ExpenseClaimViewModel>();
  @Output() clone: EventEmitter<ExpenseClaimViewModel> = new EventEmitter<ExpenseClaimViewModel>();
  @Output() approve: EventEmitter<ExpenseClaimViewModel> = new EventEmitter<ExpenseClaimViewModel>();
  @Output() markAsPaid: EventEmitter<string> = new EventEmitter<string>();
  @Output() revertToPending: EventEmitter<string> = new EventEmitter<string>();
  @Output() reject: EventEmitter<string> = new EventEmitter<string>();
  @Output() startInvestigation: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeInvestigation: EventEmitter<string> = new EventEmitter<string>();
  @Output() refreshResult: EventEmitter<any> = new EventEmitter<any>();

  Permissions = Permissions;
  ExpenseCategoryType = ExpenseCategoryType;
  ExpenseClaimState = ExpenseClaimState;
  wipBusy: boolean = false;

  constructor(public authService: AuthService, private expenseService: ExpenseService, private alertService: AlertService) { }

  propagateResult() {
    if (this.expense.categoryType === ExpenseCategoryType.Distance) {
      this.refreshResult.emit();
    }
  }

  onHandleSetWip() {
    this.confirmWipModal.showConfirmSetWip()
  }

  onHandleUnsetWip() {
    this.confirmWipModal.showConfirmUnsetWip();
  }

  onHandleSetWipConfirmed(allExpenses: boolean = false) {
    this.wipBusy = true;
    this.expenseService.startWip(this.expense.id, allExpenses).subscribe({
      next: () => {
        this.wipBusy = false;
        this.refreshResult.emit();
      },
      error: error => {
        this.wipBusy = false;
        LogHelper.log(error);
        this.alertService.showErrorAlert(error);
      }
    });
  }

  onHandleUnsetWipConfirmed(allExpenses: boolean = false) {
    this.wipBusy = true;
    this.expenseService.finishWip(this.expense.id, allExpenses).subscribe({
      next: () => {
        this.wipBusy = false;
        this.refreshResult.emit();
      },
      error: error => {
        this.wipBusy = false;
        LogHelper.log(error);
        this.alertService.showErrorAlert(error);
      }
    });
  }

  protected readonly RoleNames = RoleNames;
}
